import React, { useState } from 'react';
import "./ProjectCardStyle.css";
import {FaArrowRight, FaLinkedin, FaChevronDown, FaChevronUp, FaGlobe} from "react-icons/fa";
import {FiGithub} from "react-icons/fi";
import Tilt from 'react-parallax-tilt';

export default function ProjectCard(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const handleOnClick = () => {
    window.open(`${props.projectLink}`);
  }
  const isLinkedIn = props.ctaType === 'linkedin';
  const isWebsite = props.ctaType === 'website';

  // Get brief description (first 150 characters or use provided brief)
  const briefDesc = props.briefDesc || (props.projectDesc.length > 150 
    ? props.projectDesc.substring(0, 150) + '...' 
    : props.projectDesc);

  return (
    <div className='project-window' id = {props.id}>
      <div className={`project-wrapper ${props.className}`}>
        <div className="about-project">
          <div className="project-title">{props.projectTitle}</div>
          
          <div className="desc">
            {isExpanded ? props.projectDesc : briefDesc}
          </div>

          {(props.projectDesc.length > 150 || props.briefDesc) && (
            <button 
              className='read-more-btn' 
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <span>{isExpanded ? 'Show Less' : 'Read More'}</span>
              {isExpanded ? (
                <FaChevronUp size={14} style={{marginLeft: "6px"}} />
              ) : (
                <FaChevronDown size={14} style={{marginLeft: "6px"}} />
              )}
            </button>
          )}
          
          {isExpanded && props.technologies && props.technologies.length > 0 && (
            <div className="tech-stack">
              <div className="tech-stack-title">Technology:</div>
              <div className="tech-tags">
                {props.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
            </div>
          )}

          <button className='btn' onClick={handleOnClick}>
            <span>
              {isWebsite ? 'Visit Website' : 'View on'}
              {isLinkedIn ? (
                <FaLinkedin className="social" size={20} style={{ marginLeft: "8px", position: "relative", top: "2px" }} />
              ) : isWebsite ? (
                <FaGlobe className="social" size={20} style={{ marginLeft: "8px", position: "relative", top: "2px" }} />
              ) : (
                <FiGithub className="social" size={20} style={{ marginLeft: "8px", position: "relative", top: "2px", strokeWidth: "3" }} />
              )}
            </span>
            <FaArrowRight className='btn-arrow' size={22} style={{marginLeft: "1rem"}}/>
          </button>
        </div>
        
        <Tilt className="project-img" gyroscope={true}>
          <a href={props.deployedProjectLink} target="_blank" rel="noopener noreferrer">
            <img src={props.projectImg} alt="Displaying Project" />
          </a>
        </Tilt>

      </div>
    </div>
  )
}